import { Component, OnInit } from '@angular/core';

import { WindowRef } from '@ca/core/services';
import { environment } from '@ca/environment/environment';

@Component({
    selector: 'ca-implicit-signup',
    templateUrl: './implicit-signup.component.html',
    styleUrls: ['./implicit-signup.component.scss'],
})
export class ImplicitSignupComponent implements OnInit {
    constructor(private windowRef: WindowRef) {}

    ngOnInit(): void {
        this.windowRef.nativeWindow.location.href = environment.signupUrl;
    }
}
